import { render } from "./VideoUploader.vue?vue&type=template&id=24f41d7e&scoped=true"
import script from "./VideoUploader.vue?vue&type=script&lang=js"
export * from "./VideoUploader.vue?vue&type=script&lang=js"

import "./VideoUploader.vue?vue&type=style&index=0&id=24f41d7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f41d7e"]])

export default __exports__